import {
  FieldBuilder,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  MenuCategories,
  MenuSubcategories,
} from '@zendra/shared';

FieldBuilder.setNamespace('Geographic');

export const GISPROTECTEDAREAINCONSISTENCYONLYINGIS_FIELDS = [
  FieldBuilder.text('name', 'Entity.GisProtectedAreaInconsistency.Name').readOnly().build(),
  FieldBuilder.number('area', 'Entity.GisProtectedAreaInconsistency.Area').decimal().readOnly().build(),
  FieldBuilder.dropdown('conservationType', 'Entity.GisProtectedAreaInconsistency.ConservationType')
    .options([
      { key: '', value: '' },
      { key: 'AMR', value: 'AMR' },
      { key: 'AC', value: 'AC' },
      { key: 'CB', value: 'CB' },
      { key: 'AAVC', value: 'AAVC' },
    ])
    .readOnly()
    .build(),
];

export const GISPROTECTEDAREAINCONSISTENCY_PERMISSION = 'PlanningGeography.ProtectedAreas';

export const GISPROTECTEDAREAINCONSISTENCYONLYINGIS_CONFIG = {
  entityName: 'GisProtectedAreaInconsistencyOnlyInGis',
  localizationKey: 'Geographic::Entity.GisProtectedAreaInconsistency.OnlyInGis',
  fields: GISPROTECTEDAREAINCONSISTENCYONLYINGIS_FIELDS,
  permission: GISPROTECTEDAREAINCONSISTENCY_PERMISSION,
  showInMenu: false,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.QueriesPlanning + MENU_NAME_SUFFIX,
};
